// extracted by mini-css-extract-plugin
module.exports = {"basket":"basket__3nU21","counter":"counter__3S2Fl"};